import {optionContract, OptionContract} from "./contract/OptionContractComponent";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.components`;

    return angular.module(moduleName, [])
                  .component(OptionContract, optionContract())
                  .name;
}
